import { Text, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import { AdminScreen } from './AdminScreen'
import { ADMIN_SECTION_ROUTE_BY_NAME } from './adminRoutes'
import type { AdminSectionRouteName } from './adminRoutes'

interface AdminPlaceholderScreenProps {
  routeName: AdminSectionRouteName
}

export function AdminPlaceholderScreen({ routeName }: AdminPlaceholderScreenProps) {
  const { t } = useTranslation()
  const sectionRoute = ADMIN_SECTION_ROUTE_BY_NAME[routeName]

  return (
    <AdminScreen
      title={t(sectionRoute.titleKey)}
      subtitle={t(sectionRoute.subtitleKey)}
    >
      <View className="rounded-xl border border-border bg-canvas-card p-6">
        <Text className="text-base font-normal text-secondary">{t('placeholder.adminReady')}</Text>
      </View>
    </AdminScreen>
  )
}
